import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import { UpgradeWebModal } from 'design-system/UpgradeWebModal';
import useStyles from 'hooks/useStyles';
import ProgressCard from 'features/invest/components/InvestOnboardingFunnel/ProgressCard';
import { selectAutosaveFees } from 'features/pots/reducers/selectors';
import { formatDateForItem } from 'utils';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { isWeb } from '../../../../constants';
import AutosaveRulePaymentRow from './AutosaveRulePaymentRow';
const InitiatedInfoCard = ({ fee, timeStamp, rules, isForPot }) => {
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const fees = useAppSelector(selectAutosaveFees);
    const upgrade = useCallback(() => {
        if (isWeb) {
            UpgradeWebModal.show(undefined);
            return;
        }
        navigation.navigateDeprecated('EmmaProModal', {});
    }, []);
    return (<View testID="initiatedView">
      <ProgressCard lightBg noTextDecoration alwaysShowTimeline alwaysShowChildren completed title="Deposit initiated" timeInfo={formatDateForItem(new Date(timeStamp))}>
        <Text TextThin-14 Secondary>
          We’ve sent the payment request to your bank.
        </Text>
        {!isForPot && (<>
            {rules.map((rule) => (<View style={styles.rulePaymentWrapper} key={rule.type}>
                <AutosaveRulePaymentRow rule={rule}/>
              </View>))}
            {!!fee && (<View style={styles.rulePaymentWrapper}>
                <AutosaveRulePaymentRow rule={{ type: 'fee', amount: fee }}/>
              </View>)}
          </>)}
        {!!fees && (<TouchableBounce style={styles.feeInfo} onPress={upgrade}>
            <Text TextThin-14 OnBrand>
              Free autosaves
            </Text>
            <Text Text-14 OnBrand>
              Upgrade
            </Text>
          </TouchableBounce>)}
      </ProgressCard>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    rulePaymentWrapper: {
        paddingTop: rem(8),
    },
    feeInfo: {
        marginTop: rem(16),
        alignItems: 'center',
        borderRadius: rem(8),
        flexDirection: 'row',
        paddingVertical: rem(8),
        paddingHorizontal: rem(16),
        justifyContent: 'space-between',
        backgroundColor: colors.buttons.brandGroup,
    },
}));
export default memo(InitiatedInfoCard);
